import React, { memo } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Card, CardBody, Col } from "reactstrap"

const Settings = ({
  title = "",
  colSize = 3,
  store_details = {},
  store_domain = "",
  store_status = ""
}) => {
  return (
    <Col xl={colSize}>
      <Card>
        <CardBody>
          <div className="d-flex flex-wrap d-between-flex">
            <h3 className="card-title mb-3 me-2">{title}</h3>
            <Link
              to={{
                pathname: "/common-setting-edit",
                search: `?store=${encodeURIComponent(store_domain)}`,
                state: { data: { store_domain, store_details, store_status } },
              }}
            >
              <i className="fa fa-edit"></i> Edit
            </Link>
          </div>
          <div>
            <h6 className="mb-2">
              Campaigns &thinsp; &thinsp;
              <span style={{ color: "Highlight" }}>{String(store_details?.is_campaign_links || false)}</span>
            </h6>
            <h6 className="mb-2">
              Coupon Blocker &thinsp; &thinsp;
              <span style={{ color: "Highlight" }}>{String(store_details?.is_coupon_blocker || false)}</span>
            </h6>
            <h6 className="mb-2">
              Smart Discount &thinsp; &thinsp;
              <span style={{ color: "Highlight" }}>{String(store_details?.is_smart_discount || false)}</span>
            </h6>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

Settings.propTypes = {
  title: PropTypes.string,
  colSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  store_details: PropTypes.object,
  store_domain: PropTypes.string,
  store_status: PropTypes.string,
}

export default memo(Settings)